import { z } from 'zod';
import { decodeHtmlEntities } from '@utils/common';
import { twentyThreeAudioSchema } from '../schema.twenty-three-audio.js';
import { bindInputMaker } from '../util.make-input.js';

const baseSchema = z.object({
  fixed: z.boolean(),
  correctAnswer: z.number().nullable().default(null)
});
const audioSchema = baseSchema.extend({
  type: z.literal("Audio"),
  title: z.string().transform(it => decodeHtmlEntities(it)),
  src: z.string().nullish().default(null),
  twentyThreeAudio: twentyThreeAudioSchema
}).transform(({
  twentyThreeAudio,
  ...rest
}) => ({
  ...rest,
  src: twentyThreeAudio?.src || rest.src || ""
}));
const imageSchema = baseSchema.extend({
  type: z.literal("Image"),
  title: z.string().transform(it => decodeHtmlEntities(it)),
  src: z.string(),
  audioSrc: z.string().nullable().default(null),
  altText: z.string().nullish().default(null),
  twentyThreeAudio: twentyThreeAudioSchema
}).transform(({
  twentyThreeAudio,
  ...rest
}) => ({
  ...rest,
  audioSrc: twentyThreeAudio?.src || rest.audioSrc
}));
const textSchema = baseSchema.extend({
  type: z.literal("Text"),
  text: z.string().transform(it => decodeHtmlEntities(it))
});
const makeInput = bindInputMaker();
const groupTileInput = makeInput({
  entry: {
    schema: z.object({
      type: z.literal("group-tile").default("group-tile"),
      dropzoneId: z.string().default(""),
      order: z.number().default(0)
    }),
    shouldValidate: (node, entry) => node.validation.expectedDropzoneId != null || !!entry?.dropzoneId,
    validate: (node, entry) => node.validation.expectedDropzoneId === entry.dropzoneId,
    // NB: items here consists of an entire group.
    parseLegacyDetailItem: (item, context) => {
      if (["Group"].includes(context.relatedTask.taskType) && Array.isArray(item) && item.length > 0) {
        const typedTask = context.relatedTask;
        const dropzone = typedTask.groups[context.indexInDetails];
        if (!dropzone) {
          return undefined;
        }
        return item.map((tileIndex, index) => {
          const tile = typedTask.__orderedContent[tileIndex];
          if (!tile) {
            return undefined;
          }
          return [tile.id, {
            type: "group-tile",
            dropzoneId: dropzone.id,
            order: index
          }];
        }).filter(it => !!it);
      }
    }
  },
  schema: z.discriminatedUnion("type", [audioSchema, imageSchema, textSchema]),
  postprocessSchemaInput: ({
    fixed,
    correctAnswer,
    ...input
  }, context) => {
    return {
      ...input,
      id: `${context.taskId}-${context.index}`,
      nodeType: "group-tile-input",
      options: {
        fixed
      },
      validation: {
        expectedDropzoneId: typeof correctAnswer === "number" ? String(correctAnswer) : null
      }
    };
  }
});

export { groupTileInput };
//# sourceMappingURL=input.tile.js.map
